import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API } from '../config/api';

@Injectable()
export class LabelService {
  constructor(private _http: HttpClient) {

  }


  public getAsapLabel(id: string) {
    return this._http.get(`${API.SERVER_PRINT.ASAP_LABEL(id)}`, { responseType: 'blob' });
  }
  public getDxLabel(id: string) {
    return this._http.get(`${API.SERVER_PRINT.DX_LABEL(id)}`, { responseType: 'blob' });
  }
  public getPfTPNLabel(id: string) {
    return this._http.get(`${API.SERVER_PRINT.PF_TPN_LABEL(id)}`, { responseType: 'blob' });
  }
}
